declare const FeLibrary: {
  Toast: {
    getOrCreateInstance: (element: HTMLElement, options?: { animation: boolean; autohide: boolean; delay: number }) => {
      show: () => void;
      hide: () => void;
      dispose: () => void;
    };
  };
};

export default class Toasts {
  /**
   * Initializes the toast element.
   * @param {any} elementId The element ID.
   * @param {any} autohide If the toast should autohide.
   * @param {any} delay The delay.
   * @param {any} dotNetHelper The DotNet helper.
   */
  static show(elementId: any, autohide: any, delay: any, dotNetHelper: any) {
    let toastEl = document.getElementById(elementId);
    if (toastEl == null) 
      return;

    toastEl.addEventListener('show.fe.toast', function () {
      dotNetHelper.invokeMethodAsync('BlazorShowToast');
    });

    toastEl.addEventListener('shown.fe.toast', function () {
      dotNetHelper.invokeMethodAsync('BlazorShownToast');
    });

    toastEl.addEventListener('hide.fe.toast', function () {
      let _this = toastEl;
      // when a user is redirected to a different page, the HTML element becomes unavailable.
      if (_this == null || document.getElementById(_this.id) == null) 
        return;

      dotNetHelper.invokeMethodAsync('BlazorHideToast');
    });

    toastEl.addEventListener('hidden.fe.toast', function () {
      let _this = toastEl;
      // when a user is redirected to a different page, the HTML element becomes unavailable.
      if (_this == null || document.getElementById(_this.id) == null) 
        return;

      dotNetHelper.invokeMethodAsync('BlazorHiddenToast');
    });

    let options = { animation: true, autohide: autohide, delay: delay };
    FeLibrary?.Toast?.getOrCreateInstance(toastEl, options)?.show();
  }

  /**
   * Hides the toast
   * @param {any} elementId The element ID.
   */
  static hide(elementId: any) {
    let toastEl = document.getElementById(elementId);
    if (toastEl != null) FeLibrary?.Toast?.getOrCreateInstance(toastEl)?.hide();
  }

  /**
   * Disposes the toast
   * @param {any} elementId The element ID.
   */
  static dispose(elementId: any) {
    let toastEl = document.getElementById(elementId);
    if (toastEl != null) FeLibrary?.Toast?.getOrCreateInstance(toastEl)?.dispose();
  }
}